import { Component } from '@angular/core';
import {CommonModule, formatDate, NgFor} from '@angular/common';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { Partner } from '../interfaces/partner';
import { StorePartnerService } from '../services/store-partner.service';
import { inject } from '@angular/core';
import firebase from 'firebase/compat/app';
import { doc, DocumentData, getDoc, query } from 'firebase/firestore';
import {ActivatedRoute, RouterLink} from '@angular/router';
import { UserService } from '../services/user.service';
import { docSnapshots } from '@angular/fire/firestore';
import { PartnerFormComponent } from "../partner-form/partner-form.component";
import { PartnerService } from '../services/partner.service';
import {TeacherService} from "../services/teacher.service";
import {Teacher} from "../interfaces/teacher";

@Component({
  standalone: true,
  selector: 'app-partnerprofile',
  templateUrl: './partner-profile.component.html',
  styleUrls: [
    './partner-profile.component.css',
    '../app.component.css'
  ],
  imports: [
    NgFor,
    CommonModule,
    PartnerFormComponent,
    RouterLink,
  ]
})

export class PartnerProfileComponent {
  storePartnerServ = inject(StorePartnerService);
  constructor(private store: AngularFirestore, private route: ActivatedRoute, private userService: UserService, private teacherService: TeacherService) { }
  partner!: Partner;
  partnerUrlId!: string;
  isAdmin = false;
  isApproved = true;
  isRecycled = false
  isEditing = false;
  partnerLoaded = false;
  teacher: Teacher | null = null;
  teacherRole: string | undefined = undefined;

  partnerService = inject(PartnerService)
  async ngOnInit() {
    this.partnerUrlId = this.route.snapshot.paramMap.get('id')!;
    await this.getPartner();
    this.teacher = await this.teacherService.getTeacher();
    this.teacherRole = this.teacher?.role.toLowerCase()
    this.userService.isAdmin$.subscribe((isAdmin) => {
      this.isAdmin = isAdmin;
    });
  }

  onPartnerFormSubmitted(partnerData: Partner) {
    //console.log(partnerData);
    if (partnerData.id) {
      this.partnerService.editPartner(partnerData.id, partnerData).subscribe({
        next: () => {
          this.partner = partnerData;
          this.isEditing = false;
          window.location.reload(); // reload the page so that all the data appear
        },
        error: (err) => {
          alert("Something went wrong. Check console for error.");
          console.error('Error updating partner:', err);
        }
      });
    } else {
      alert("Partner has no ID.")
    }
  }

  async recyclePartner() {
    try {
      const querySnapshot = await firebase.firestore()
        .collection('pendingPartners')
        .where('urlOrg', '==', this.partnerUrlId)
        .get();

      if (!querySnapshot.empty) {
        const data = querySnapshot.docs[0].data() as DocumentData;
        await firebase.firestore().collection('recycledPartners').doc(querySnapshot.docs[0].id).set(data);
        await firebase.firestore().collection('pendingPartners').doc(querySnapshot.docs[0].id).delete();
        location.reload();
      }
    } catch (error) {
      console.error('Error recycling partner: ', error);
    }
  }

  async unrecyclePartner() {
    try {
      const querySnapshot = await firebase.firestore()
        .collection('recycledPartners')
        .where('urlOrg', '==', this.partnerUrlId)
        .get();

      if (!querySnapshot.empty) {
        const data = querySnapshot.docs[0].data() as DocumentData;
        await firebase.firestore().collection('pendingPartners').doc(querySnapshot.docs[0].id).set(data);
        await firebase.firestore().collection('recycledPartners').doc(querySnapshot.docs[0].id).delete();
        location.reload();
      }
    } catch (error) {
      console.error('Error unrecycling partner: ', error);
    }
  }

  async approvePartner() {
    try {
      const querySnapshot = await firebase.firestore()
        .collection('pendingPartners')
        .where('urlOrg', '==', this.partnerUrlId)
        .get();

      if (!querySnapshot.empty) {
        const data = querySnapshot.docs[0].data() as DocumentData;
        await firebase.firestore().collection('partner').doc(querySnapshot.docs[0].id).set(data);
        await firebase.firestore().collection('pendingPartners').doc(querySnapshot.docs[0].id).delete();
        location.reload();
      }
    } catch (error) {
      console.error('Error approving partner: ', error);
    }
  }

  editPartner() {
    this.isEditing = !this.isEditing;
  }



  async unapprovePartner() {
    try {
      const querySnapshot = await firebase.firestore()
        .collection('partner')
        .where('urlOrg', '==', this.partnerUrlId)
        .get();

      if (!querySnapshot.empty) {
        const data = querySnapshot.docs[0].data() as DocumentData;
        await firebase.firestore().collection('pendingPartners').doc(querySnapshot.docs[0].id).set(data);
        await firebase.firestore().collection('partner').doc(querySnapshot.docs[0].id).delete();
        location.reload();
      }
    } catch (error) {
      console.error('Error unapproving partner: ', error);
    }
  }

  async getPartner() {
    try {
      let querySnapshot = await firebase.firestore()
        .collection('partner')
        .where('urlOrg', '==', this.partnerUrlId)
        .get();

      if (querySnapshot.empty) {
        querySnapshot = await firebase.firestore()
          .collection('pendingPartners')
          .where('urlOrg', '==', this.partnerUrlId)
          .get();

        this.isApproved = false
      }

      if (querySnapshot.empty) {
        querySnapshot = await firebase.firestore()
          .collection('recycledPartners')
          .where('urlOrg', '==', this.partnerUrlId)
          .get();

        if (!querySnapshot.empty) {
          this.isRecycled = true
        }
      }



      if (!querySnapshot.empty) {
        const docSnapshot = querySnapshot.docs[0];
        const data = { id: docSnapshot.id, ...docSnapshot.data() };
        this.partner = data as Partner;
        this.partnerLoaded = true;
      }
    } catch (error) {
      console.error('Error fetching partner details: ', error);
    }
  }

  protected readonly formatDate = formatDate;
  protected readonly Date = Date;

  isDeleting = false;
  deletePartner() {
    if (!confirm("Are you sure you want to delete this partner?")) return;
    this.isDeleting = true;

    return firebase.firestore()
      .collection('partner')
      .doc(this.partner.id)
      .set({ isDeleted: true }, { merge: true })
      .catch(err => {
        console.error(err);
        this.isDeleting = false;
      });
  }

  undeletePartner() {
    if (!confirm("Are you sure you want to undelete this partner?")) return;
    this.isDeleting = true;

    return firebase.firestore()
      .collection('partner')
      .doc(this.partner.id)
      .set({ isDeleted: false }, { merge: true })
      .then(() => {
        this.partner.isDeleted = false;
        this.isDeleting = false;
      })
      .catch(err => {
        console.error(err);
        this.isDeleting = false;
      });
  }

  formatPhone(value: string): string {
    if (!value) return '';
    const digits = value.replace(/\D/g, '');
    if (digits.length !== 10) return value;
    return `${digits.slice(0,3)}-${digits.slice(3,6)}-${digits.slice(6)}`;
  }
}
